import React from "react"
import SVG from "react-inlinesvg"
import { toAbsoluteUrl } from "../../../../_metronic/_helpers"
import { ICON_CONSTANTS } from "../../../../constants/ImageConstants.js"

export const UploadIcon = () => {
  return (
    <div className="upload-area">
      <SVG src={toAbsoluteUrl(ICON_CONSTANTS.UPLOAD)} />
      <h4>
        Drag files here of click to upload, or <span>browse.</span>
      </h4>
    </div>
  )
}

export const AddImage = () => {
  return (
    <div className="upload-area">
      <SVG src={toAbsoluteUrl(ICON_CONSTANTS.ADD_IMAGE)} />
      <span className={"text-center"}>Add image here</span>
    </div>
  )
}

export const ErrorSizeUploadIcon = ({ maxSize }) => {
  return (
    <div className="upload-area">
      <SVG src={toAbsoluteUrl(ICON_CONSTANTS.DANGER)} />
      <h4>
        File yang diupload lebih dari {maxSize}
        <br />
        <span>Ganti File</span>
      </h4>
    </div>
  )
}

export const MultipleUploadSizeError = () => {
  return (
    <>
      <div className="upload-area">
        <SVG src={toAbsoluteUrl(ICON_CONSTANTS.DANGER)} />
        <h4>Melebihi akumulasi maksimal ukuran file</h4>
      </div>
    </>
  )
}

export const ErrorSizeLength = () => {
  return (
    <div className="upload-area">
      <SVG src={toAbsoluteUrl(ICON_CONSTANTS.DANGER)} />
      <h4>Jumlah file yang di uopload melebihi maksimal.</h4>
    </div>
  )
}
